<template>
  <div class="list-item d-grid mb-3" :class="classFromColorIndex(colorIndex, 'border-primary','border-secondary')">
    <div class="main-info">
      <slot name="pre-title" />
      <a :href="actionUrl" target="_blank"><h3 class="title" :class="classFromColorIndex(colorIndex, 'text-primary','text-secondary')">{{ displayTitle }}</h3></a>
      <slot name="post-title" />
      <div class="text-content">
        <slot name="content" />
      </div>
    </div>
    <action-button :action-url="actionUrl" size="lg" :color-index="colorIndex">
      <template #action-button-text>
        <slot name="action-button-text" />
      </template>
    </action-button>
  </div>
</template>

<script>
import ActionButton from '../components/buttons/action-button'
import truncate from 'lodash/truncate'

const TITLE_TRUNCATED_LENGTH = 60

export default {
  components: {
    ActionButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    actionUrl: {
      type: String,
      required: true
    },
    colorIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    displayTitle() {
      return truncate(this.title, { 'length': TITLE_TRUNCATED_LENGTH })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  padding: 15px 20px 20px 20px;
  min-height: 200px;
  background-color: white;
  border-top-width: 4px;
  border-top-style: solid;
}

.text-content {
  font-size: 15px;
  margin-top: 10px;
  word-break: break-word;
}

.title {
  margin-top: 10px;
  margin-bottom: 0;
  word-break: break-word;
}

.action-button {
  border-radius: 0;
  margin: 20px 0 0 0;
}
</style>
